import { isEmpty, isEmail, isOnlyDigits, isAlphabetsWithSpace } from './validators'

export default function validateAuth(values) {
    let errors = {};
    Object.keys(values).map(key => {
        switch (key) {
            case "name":
                if (!values.name) {
                    errors.name = "Please enter valid name";
                }
                else if (!isEmpty(values.name) && !isAlphabetsWithSpace(values.name.trim())) {
                    errors.name = "Full name should have only alphabats and space only";
                }
                break;
            case "email":
                if (isEmpty(values.email)) {
                    errors.email = "Email ID cannot be left blank";
                } else if (!isEmail(values.email)) {
                    errors.email = "Email ID format should be : name@example.com";
                }
                break;
           
        }
        console.log(errors)
    });

    return errors;
}
